import { authApiCall } from "../../../auth";

export const getPointsTransactions = () => {
  return authApiCall({
    url: `/points/points-transactions/`,
    method: 'get',
  });
};
